<template>
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_21682_59163)">
            <path
                d="M0.572266 1.14307H15.4294"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M0.572266 4.57178H12.0008"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M0.572266 8H8.57227"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M0.572266 14.8574H15.4294"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M0.572266 11.4287H12.0008"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_21682_59163">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
